import Vue from 'vue';
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faMapPin, faFilter, faBuilding, faPaintBrush, faHelmetBattle, faMicrochip, faLayerGroup, faListAlt, faTimes, faGlobe, faBars, faSearch } from '@fortawesome/pro-light-svg-icons';
import { faFacebook, faTiktok, faWikipediaW, faGoogle, faYoutube, faReddit, faTwitter, faInstagram } from '@fortawesome/free-brands-svg-icons';
import '@shared/vendors/custom-icons';

library.add(faBuilding, faPaintBrush, faTiktok, faWikipediaW, faHelmetBattle, faMicrochip, faLayerGroup, faListAlt, faMapPin, faBars, faFilter, faTimes, faGlobe, faYoutube, faSearch, faFacebook, faGoogle, faReddit, faTwitter, faInstagram);
Vue.component('fa-icon', FontAwesomeIcon);
